import { installAppUpdateChecks } from '@stl/composables/appUpdate';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      name: 'login',
      path: '/login',
      meta: { layout: 'blank' },
      component: () => import('@/views/LoginView.vue')
    },
    {
      name: 'loggedout',
      path: '/loggedout',
      redirect: '/'
    },
    {
      path: '/',
      redirect: '/devices'
    },
    {
      name: 'devices',
      path: '/devices',
      component: () => import('@/views/DevicesView.vue')
    }
  ]
});

installAppUpdateChecks(router);

export default router;
